import axios from 'axios'
import { Message, Loading } from 'element-ui'
import config from './config'

let loading
const instance = axios.create({
  timeout: config.timeout,
  headers: { 'content-type': 'application/json' }
})

instance.interceptors.request.use(
  reqConfig => {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    reqConfig.headers.token = localStorage.getItem('token') || ''
    return reqConfig
  },
  error => {
    if (loading) loading.close()
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    if (loading) loading.close()
    if (response.data.code === 200) {
      return response
    }
    Message.error(response.data.msg || '请求失败')
    return Promise.reject(response.data)
  },
  error => {
    if (loading) loading.close()
    Message.error(error.message || '系统错误')
    return Promise.reject(error)
  }
)

export default instance
